import { render } from "./FirstLogin.vue?vue&type=template&id=5fc467aa"
import script from "./FirstLogin.vue?vue&type=script&lang=js"
export * from "./FirstLogin.vue?vue&type=script&lang=js"
script.render = render

export default script